import Constant from '@/common/constant/Constant';

import { DropFile } from '@/component/common/DropFile';
export default function ReplyEmailAttachment({
    detailTicket,
    fieldData,
    replyToEmailTicket,
    register,
    setValue,
    getValues,
    setError,
    clearErrors,
    errorlist,
    setIsEdited,
    fileReplyUploadList,
    setFileReplyUploadList
}) {

    let props = {
        fileUploadList: fileReplyUploadList,
        setFileUploadList: setFileReplyUploadList,
        name:fieldData.id,
        data:fieldData,
        selectTicketType: Constant.HELPDESK_CREATE_TICKET_TYPE.EMAIL,
        ticketType: Constant.TICKET_TYPE.EMAIL,
        detailTicket: detailTicket,
        setErrorCreateTicket: setError,
        setError: setError,
        errorlist: errorlist,
        fileUploading: [],
        componentName: null,
        addTicket: true,
        setValue,
        register,
        clearErrors,
        setIsEdited,
    }
    return <DropFile {...props} />;
   
}
